// Booking status colors (lifecycle)
export const BOOKING_STATUS_COLORS: Record<string, string> = {
  draft: 'bg-gray-100 text-gray-700',
  quoted: 'bg-blue-100 text-blue-800',
  accepted: 'bg-amber-100 text-amber-800',
  confirmed: 'bg-green-100 text-green-800',
  si_submitted: 'bg-purple-100 text-purple-800',
  bl_released: 'bg-emerald-100 text-emerald-800',
  cancelled: 'bg-red-100 text-red-800',
  transferred: 'bg-gray-100 text-gray-700',
}

// Draft reply status colors
export const DRAFT_STATUS_COLORS: Record<string, string> = {
  pending: 'bg-amber-100 text-amber-800',
  editing: 'bg-blue-100 text-blue-800',
  edited: 'bg-purple-100 text-purple-800',
  approved: 'bg-green-100 text-green-800',
  sent: 'bg-green-100 text-green-800',
  rejected: 'bg-red-100 text-red-800',
  send_failed: 'bg-red-100 text-red-800',
  superseded: 'bg-gray-100 text-gray-500',
}

// Agent session status colors
export const AGENT_SESSION_STATUS_COLORS: Record<string, string> = {
  completed: 'bg-green-100 text-green-800',
  failed: 'bg-red-100 text-red-800',
  running: 'bg-blue-100 text-blue-800',
}

// Booking form options
export const BOOKING_STATUSES = [
  { value: '', label: 'Select status...' },
  { value: 'draft', label: 'Draft' },
  { value: 'quoted', label: 'Quoted' },
  { value: 'accepted', label: 'Accepted by client' },
  { value: 'confirmed', label: 'Confirmed by carrier' },
  { value: 'si_submitted', label: 'SI Submitted' },
  { value: 'bl_released', label: 'BL Released' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'transferred', label: 'Transferred' },
]

export function bookingStatusLabel(status: string | null | undefined): string {
  return BOOKING_STATUSES.find(option => option.value === status)?.label || (status || '')
}

export const CONTAINER_TYPES = [
  { value: '', label: 'Select type...' },
  { value: '22GP', label: "20GP — 20' General Purpose" },
  { value: '42GP', label: "40GP — 40' General Purpose" },
  { value: '45GP', label: "40HC — 40' High Cube" },
  { value: 'L5GP', label: "45HC — 45' High Cube" },
  { value: '22RT', label: "20RF — 20' Reefer" },
  { value: '42RT', label: "40RF — 40' Reefer" },
  { value: '45RT', label: "40RH — 40' High Cube Reefer" },
  { value: '22UT', label: "20OT — 20' Open Top" },
  { value: '42UT', label: "40OT — 40' Open Top" },
  { value: '22PC', label: "20FR — 20' Flatrack" },
  { value: '42PC', label: "40FR — 40' Flatrack" },
]

const CONTAINER_TYPE_MAP: Record<string, string> = Object.fromEntries(
  CONTAINER_TYPES.filter(t => t.value).map(t => [t.value, t.label])
)

// Full label for detail views: "40HC — 40' High Cube"
export function formatContainerType(isoCode: string | null | undefined): string {
  if (!isoCode) return ''
  return CONTAINER_TYPE_MAP[isoCode] || isoCode
}

// Short label for inline display: "40HC"
export function shortContainerType(isoCode: string | null | undefined): string {
  if (!isoCode) return ''
  const label = CONTAINER_TYPE_MAP[isoCode]
  return label ? label.split(' — ')[0] : isoCode
}
